/**
 * Brand Configuration Loader
 * White-Label Architecture - Loads brand config based on domain or environment
 */

import toilestorebanne from './brands/toilestorebanne.json';
import qualitoiles from './brands/qualitoiles.json';

// Map of domains to brand configs
const brandsByDomain = {
  'toilestorebanne.com': toilestorebanne,
  'www.toilestorebanne.com': toilestorebanne,
  'qualitoiles.com': qualitoiles,
  'www.qualitoiles.com': qualitoiles,
};

// Map of brand IDs to configs
const brandsById = {
  'toilestorebanne': toilestorebanne,
  'qualitoiles': qualitoiles,
};

/**
 * Detect current brand based on hostname or environment variable
 */
function detectBrand() {
  // 1. Check environment variable (for deployment flexibility)
  const envBrand = process.env.REACT_APP_BRAND_ID;
  if (envBrand && brandsById[envBrand]) {
    return brandsById[envBrand];
  }
  
  // 2. Check hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Check exact domain match
    if (brandsByDomain[hostname]) {
      return brandsByDomain[hostname];
    }
    
    // Check if hostname contains brand identifier
    for (const [domain, brand] of Object.entries(brandsByDomain)) {
      if (hostname.includes(domain.replace('www.', ''))) {
        return brand;
      }
    }
  }
  
  // 3. Default to toilestorebanne
  return toilestorebanne;
}

// Current brand configuration
export const brand = detectBrand();

// Export individual brand configs for direct access if needed
export { toilestorebanne, qualitoiles };

// Helper functions
export const getBrandColor = (colorName) => brand.colors[colorName] || brand.colors.primary;
export const getBrandName = () => brand.name;
export const getBrandDomain = () => brand.domain;
export const getBrandContact = () => brand.contact;
export const getBrandSEO = () => brand.seo;
export const getBrandLogo = () => brand.logo;

// Generate CSS variables for the current brand
export const generateCSSVariables = () => {
  return {
    '--brand-primary': brand.colors.primary,
    '--brand-primary-dark': brand.colors.primaryDark,
    '--brand-primary-light': brand.colors.primaryLight,
    '--brand-secondary': brand.colors.secondary,
    '--brand-accent': brand.colors.accent,
    '--brand-accent-hover': brand.colors.accentHover,
  };
};

export default brand;
